import { render } from "./index.vue?vue&type=template&id=3f4a4340&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=3f4a4340&lang=scss&scoped=true"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4a4340"]])

export default __exports__